<template>
  <!-- 插入功能面板组件 -->
  <div class="insert-panel" v-if="visible" :style="panelStyle">
    <!-- 遮罩层 -->
    <div class="insert-panel-mask" @click="handleMaskClick"></div>
    
    <!-- 面板主体 -->
    <div class="insert-panel-container" :style="containerStyle">
      <!-- 面板头部 -->
      <div class="insert-panel-header">
        <span class="title">{{ title }}</span>
        <div class="close-btn" @click="close">
          <svg t="close" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
            <path d="M810.666667 273.493333L750.506667 213.333333 512 451.84 273.493333 213.333333 213.333333 273.493333 451.84 512 213.333333 750.506667 273.493333 810.666667 512 572.16 750.506667 810.666667 810.666667 750.506667 572.16 512 810.666667 273.493333Z" fill="#909399" p-id="close"></path>
          </svg>
        </div>
      </div>
      
      <!-- 功能选项列表 -->
      <div class="insert-panel-body">
        <!-- 插入图片 -->
        <div class="insert-item" :class="{ disabled: !isFeatureEnabled('image') }" @click="handleInsert('image')">
          <div class="item-icon image-icon">
            <svg t="image" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M928 128H96c-52.992 0-96 43.008-96 96v576c0 52.992 43.008 96 96 96h832c52.992 0 96-43.008 96-96V224c0-52.992-43.008-96-96-96z m32 672c0 17.664-14.336 32-32 32H96c-17.664 0-32-14.336-32-32V224c0-17.664 14.336-32 32-32h832c17.664 0 32 14.336 32 32v576z" fill="#4a4a51"></path>
              <path d="M288 448c53.024 0 96-42.976 96-96s-42.976-96-96-96-96 42.976-96 96 42.976 96 96 96z m0-128c17.664 0 32 14.336 32 32s-14.336 32-32 32-32-14.336-32-32 14.336-32 32-32z" fill="#4a4a51"></path>
              <path d="M928 768l-192-256-128 160-128-128-256 320h704z m-672-32l160-192 128 128 160-192 160 256h-608z" fill="#4a4a51"></path>
            </svg>
          </div>
          <div class="item-info">
            <div class="item-name">插入图片</div>
            <div class="item-desc">从本地上传或选择图片素材</div>
          </div>
        </div>
        
        <!-- 插入高亮块 -->
        <div class="insert-item" :class="{ disabled: !isFeatureEnabled('highlight') }" @click="handleInsert('highlight')">
          <div class="item-icon highlight-icon">
            <svg t="highlight" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M896 128H128c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96V224c0-53.024-42.976-96-96-96z m32 672c0 17.664-14.336 32-32 32H128c-17.664 0-32-14.336-32-32V224c0-17.664 14.336-32 32-32h768c17.664 0 32 14.336 32 32v576z" fill="#4a4a51"></path>
              <path d="M256 384h512v64H256zM256 512h384v64H256zM256 640h256v64H256z" fill="#4a4a51"></path>
            </svg>
          </div>
          <div class="item-info">
            <div class="item-name">插入高亮块</div>
            <div class="item-desc">添加带颜色背景的提示框</div>
          </div>
        </div>
        
        <!-- 插入分栏布局 -->
        <div class="insert-item" :class="{ disabled: !isFeatureEnabled('columns') }" @click="handleInsert('columns')">
          <div class="item-icon columns-icon">
            <svg t="columns" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M896 128H128c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96V224c0-53.024-42.976-96-96-96z m32 672c0 17.664-14.336 32-32 32H128c-17.664 0-32-14.336-32-32V224c0-17.664 14.336-32 32-32h768c17.664 0 32 14.336 32 32v576z" fill="#4a4a51"></path>
              <path d="M384 256h-64v512h64zM704 256h-64v512h64zM544 256h-64v512h64z" fill="#4a4a51"></path>
            </svg>
          </div>
          <div class="item-info">
            <div class="item-name">插入分栏布局</div>
            <div class="item-desc">创建多栏并排布局结构</div>
          </div>
        </div>
        
        <!-- 插入表格 -->
        <div class="insert-item" :class="{ disabled: !isFeatureEnabled('table') }" @click="handleInsert('table')">
          <div class="item-icon table-icon">
            <svg t="table" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M896 128H128c-53.024 0-96 42.976-96 96v576c0 53.024 42.976 96 96 96h768c53.024 0 96-42.976 96-96V224c0-53.024-42.976-96-96-96z m32 672c0 17.664-14.336 32-32 32H128c-17.664 0-32-14.336-32-32V224c0-17.664 14.336-32 32-32h768c17.664 0 32 14.336 32 32v576z" fill="#4a4a51"></path>
              <path d="M256 384h512v64H256zM256 512h160v64H256zM608 512h160v64H608zM416 512h128v64H416zM256 640h160v64H256zM608 640h160v64H608zM416 640h128v64H416z" fill="#4a4a51"></path>
            </svg>
          </div>
          <div class="item-info">
            <div class="item-name">插入表格</div>
            <div class="item-desc">创建可编辑的数据表格</div>
          </div>
        </div>
        
        <!-- 下载文件 -->
        <div class="insert-item" :class="{ disabled: !isFeatureEnabled('file') }" @click="handleInsert('file')">
          <div class="item-icon file-icon">
            <svg t="file" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
              <path d="M832 464h-68V240c0-44.8-35.2-80-80-80H340c-44.8 0-80 35.2-80 80v544c0 44.8 35.2 80 80 80h344c44.8 0 80-35.2 80-80v-184h68c6.4 0 12.8-3.2 16-8l144-144c12.8-12.8 12.8-32 0-44.8L848 468.8c-3.2-4.8-9.6-8-16-8z m-192 208H384V256h256v416z m224-176.8L768 600.8V688H384V256h256v184.8c0 9.6 4.8 19.2 12.8 25.6l150.4 150.4L864 559.2z" fill="#4a4a51"></path>
              <path d="M736 256H640c-17.6 0-32 14.4-32 32v96c0 17.6 14.4 32 32 32h96c17.6 0 32-14.4 32-32v-96c0-17.6-14.4-32-32-32z" fill="#4a4a51"></path>
            </svg>
          </div>
          <div class="item-info">
            <div class="item-name">下载文件</div>
            <div class="item-desc">上传文件供用户下载</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * InsertPanel 插入功能面板组件
 * 
 * 功能说明：
 * - 提供统一的插入入口，整合图片、高亮块、分栏布局、表格等功能
 * - 支持配置化控制各功能的显示/隐藏
 * - 提供标准化的事件回调接口
 * 
 * 使用示例：
 * ```vue
 * <InsertPanel
 *   :visible.sync="showInsertPanel"
 *   @insert="handleInsert"
 *   :features="['image', 'highlight', 'columns', 'table']"
 * />
 * ```
 * 
 * API 说明：
 * Props:
 * - visible: Boolean, v-model, 控制面板显示/隐藏
 * - features: Array, 可选功能列表，默认全部开启（['image', 'highlight', 'columns', 'table', 'file']）
 * - title: String, 面板标题
 * - position: Object, 面板位置 { x: number, y: number }
 * 
 * Events:
 * - insert(type): 点击某项功能时触发，type 为功能类型标识
 * - close: 面板关闭时触发
 */

// 导入子组件（预留扩展）
// import Id6Image from '@/components/module/course/public/id_6.vue'
// import Id10Highlight from '@/components/module/work/public/id_10.vue'
// import Id11Columns from '@/components/module/work/public/id_11.vue'
// import Id12Table from '@/components/module/work/public/id_12.vue'

export default {
  name: 'InsertPanel',
  
  props: {
    /**
     * 控制面板显示/隐藏
     * @type {Boolean}
     * @default false
     */
    visible: {
      type: Boolean,
      default: false
    },
    
    /**
     * 可用功能列表
     * @type {Array}
     * @default ['image', 'highlight', 'columns', 'table']
     */
    features: {
      type: Array,
      default: () => ['image', 'highlight', 'columns', 'table', 'file']
    },
    
    /**
     * 面板标题
     * @type {String}
     * @default '插入内容'
     */
    title: {
      type: String,
      default: '插入内容'
    },
    
    /**
     * 面板位置（相对视口的偏移）
     * @type {Object}
     * @default { x: 0, y: 0 }
     */
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    },
    
    /**
     * 主题配置（用于样式定制）
     * @type {Object}
     * @default {}
     */
    theme: {
      type: Object,
      default: () => ({})
    }
  },
  
  data() {
    return {
      // 功能配置映射表
      featureConfig: {
        image: {
          name: '插入图片',
          enabled: true
        },
        highlight: {
          name: '插入高亮块',
          enabled: true
        },
        columns: {
          name: '插入分栏布局',
          enabled: true
        },
        table: {
          name: '插入表格',
          enabled: true
        },
        file: {
          name: '下载文件',
          enabled: true
        }
      }
    }
  },
  
  computed: {
    /**
     * 面板样式
     */
    panelStyle() {
      return {
        zIndex: 9999
      }
    },
    
    /**
     * 容器样式（根据位置动态计算）
     */
    containerStyle() {
      const { x, y } = this.position
      return {
        transform: x || y ? `translate(${x}px, ${y}px)` : 'translate(0, 0)'
      }
    }
  },
  
  methods: {
    /**
     * 检查功能是否可用
     * @param {String} feature - 功能标识
     * @returns {Boolean}
     */
    isFeatureEnabled(feature) {
      if (this.features.length === 0) return true
      return this.features.includes(feature)
    },
    
    /**
     * 处理功能项点击
     * @param {String} type - 功能类型标识
     */
    handleInsert(type) {
      console.log(type, this.isFeatureEnabled(type))
      if (!this.isFeatureEnabled(type)) return
      console.log(type)
      // 触发 insert 事件，通知父组件
      this.$emit('insert', type)
      
      // 关闭面板
      this.close()
    },
    
    /**
     * 处理遮罩层点击
     */
    handleMaskClick() {
      this.close()
    },
    
    /**
     * 关闭面板
     */
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    
    /**
     * 动态添加新功能类型（扩展接口）
     * @param {String} type - 功能类型标识
     * @param {Object} config - 功能配置
     */
    addFeatureType(type, config) {
      if (!this.featureConfig[type]) {
        this.$set(this.featureConfig, type, {
          name: config.name || type,
          enabled: true,
          ...config
        })
      }
    }
  },
  
  watch: {
    visible(val) {
      if (val) {
        // 面板打开时可以执行初始化操作
        this.$emit('open')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/**
 * InsertPanel 组件样式
 * 
 * 样式配置说明：
 * - 支持通过 theme prop 进行主题定制
 * - 使用 CSS 变量便于全局调整
 * - 遵循项目视觉规范
 */

.insert-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  
  // 遮罩层
  .insert-panel-mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    pointer-events: auto;
  }
  
  // 面板容器
  .insert-panel-container {
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    min-width: 280px;
    max-width: 360px;
    pointer-events: auto;
    overflow: hidden;
    animation: fadeInUp 0.2s ease-out;
  }
  
  // 面板头部
  .insert-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
    
    .title {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }
    
    .close-btn {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius: 4px;
      transition: background-color 0.2s;
      
      &:hover {
        background-color: #F5F7FA;
      }
      
      .icon {
        width: 16px;
        height: 16px;
      }
    }
  }
  
  // 功能选项列表
  .insert-panel-body {
    padding: 8px 0;
  }
  
  // 单项功能
  .insert-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    cursor: pointer;
    transition: background-color 0.2s;
    
    &:hover {
      background-color: #F5F7FA;
    }
    
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      
      &:hover {
        background-color: transparent;
      }
    }
    
    // 图标容器
    .item-icon {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      margin-right: 12px;
      
      .icon {
        width: 24px;
        height: 24px;
      }
    }
    
    // 不同类型图标的背景色
    .image-icon {
      background-color: #ECF5FF;
      color: #409EFF;
    }
    
    .highlight-icon {
      background-color: #FDF6EC;
      color: #E6A23C;
    }
    
    .columns-icon {
      background-color: #F0F9EB;
      color: #67C23A;
    }
    
    .table-icon {
      background-color: #FEF0F0;
      color: #F56C6C;
    }
    
    .file-icon {
      background-color: #EBF5FF;
      color: #409EFF;
    }
    
    // 功能信息
    .item-info {
      flex: 1;
      
      .item-name {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 2px;
      }
      
      .item-desc {
        font-size: 12px;
        color: #909399;
      }
    }
  }
}

// 动画定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 响应式适配
@media (max-width: 480px) {
  .insert-panel {
    .insert-panel-container {
      min-width: 260px;
      max-width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/InsertPanel.vue